import React, { Component } from "react";
import { Link } from "react-router-dom";

class AdditionalPages extends Component {


  render() {
    return (<>

      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-2"></div>
            <div className="col-lg-8">

              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/WhyShopOnlinewithUs"><h5>Why Shop Online with Us</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/OnlinePaymentMethods"><h5>Online Payment Methods</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/AfterSalesSupport"><h5>After Sales Support</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/FAQ"><h5>FAQ</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/Return&RefundPolicy"><h5>Return & Refund Policy</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/PrivacyPolicy"><h5>Privacy Policy</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/TermsandConditions"><h5>Terms and Conditions</h5></Link></div>
              <div className="shadow p-2 mb-2 bg-body rounded text-center border border-light"><Link to="/admin/AboutUs"><h5>About Us</h5></Link></div>
            
            </div>
            <div className="col-lg-2"></div>
          </div>
        </div>
      </div>

    </>
    );
  }
}

export default AdditionalPages;
